import { RequestPayload } from "appworks/model/gameplay/requests/request-payload";

export class SpinRequestPayload extends RequestPayload {
    public creditPerLine: number;
    public creditSize: number;
}
